module.exports = __webpack_public_path__ + "static/imgs/data.7b67e9d.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/data.png
// module id = 0C+T
// module chunks = 1